import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 5px 0;
  display: flex;
`;

export const Form = styled.form`
  display: flex;
`;
export const Input = styled.input`
    width: 250px;
    height: 27px;
    border-radius: 5px 0 0 5px;
    border: solid 1px #cfcfcf;
    background-color: #ffffff;
    outline: none;
    padding: 3px 7px;
`;

export const Button = styled.button`
  border: none;
  width: 63px;
  height: 35px;
  background-color: #bec6d8;
  border-Radius: 0 5px 5px 0;
  color: #FFF;
  outline: none;
  font-size: 20px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
